import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import { ICONS_MAP } from 'constants/icons';

const prefix = ['components', 'wrongPage', 'icons'];

export const NotFoundIcon = styled(ICONS_MAP.NotFound)`
  .bgCircle {
    fill: ${getPrefixedVar(prefix, 'notFound', 'bgCircle')};
  }

  .dot {
    fill: ${getPrefixedVar(prefix, 'notFound', 'dot')};
  }

  .searchCircle {
    fill: ${getPrefixedVar(prefix, 'notFound', 'searchCircle')};
  }

  .search {
    stroke: ${getPrefixedVar(prefix, 'notFound', 'search')};
  }

  .rightBar {
    fill: ${getPrefixedVar(prefix, 'notFound', 'rightBar')};
  }

  .topLeftBar {
    fill: ${getPrefixedVar(prefix, 'notFound', 'topLeftBar')};
  }

  .barDot {
    fill: ${getPrefixedVar(prefix, 'notFound', 'barDot')};
  }

  .topRightBar {
    stroke: ${getPrefixedVar(prefix, 'notFound', 'topRightBar')};
  }

  .leftBar {
    fill: ${getPrefixedVar(prefix, 'notFound', 'leftBar')};
  }
`;

export const SomethingWentWrongIcon = styled(ICONS_MAP.SomethingWentWrong)`
  .bgCircle {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'bgCircle')};
  }

  .dot {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'dot')};
  }

  .bg {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'bg')};
  }

  .topBar {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'topBar')};
  }

  .questionMark {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'questionMark')};
  }

  .barDot {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'barDot')};
  }
`;

export const PermissionDeniedIcon = styled(ICONS_MAP.PermissionDenied)`
  .bgCircle {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'bgCircle')};
  }

  .dot {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'dot')};
  }

  .bg {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'bg')};
  }

  .topBar {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'topBar')};
  }

  .barDot {
    fill: ${getPrefixedVar(prefix, 'somethingWrong', 'barDot')};
  }
`;
